import { Injectable, Renderer2, Inject } from '@angular/core';
import { APP_SETTINGS } from '../../../../modules/ng-express-engine/tokens';

@Injectable()
export class ScrollingHelperService {
    renderer: Renderer2
    defaultHorizontalPosition:number = 2

    constructor(@Inject(APP_SETTINGS) private settings: any) {
        if (settings["DEFAULT_HORIZONTAL_SCROLL_POSITION"]) {
            this.defaultHorizontalPosition = settings["DEFAULT_HORIZONTAL_SCROLL_POSITION"]
        }
     }

    requestVerticalScrollPosition(elem): number {
        if (typeof(window) == "undefined") return 0;
        
        const view = elem.nativeElement,
            rowYPosition = view.offsetTop || (view.offsetParent && view.offsetParent.offsetTop),
            containerHeight = window.innerHeight;

        //viewport mid point only content below this point will initiate a vertical page scrolling 
        const viewportMidPoint = window.innerHeight / 2;
        var offset = 0.0;
        //if (direction > 0) {
        let targetYPos = rowYPosition;
        //moving downwards, only scroll if next view is hiegher than half the viewport height
        if (targetYPos > viewportMidPoint) {
            //store current y-offset amount in queue
            //this.offsetQueue.push(this.yPosition);
            //when going downwards, it calculates new centering y-offset based on view's top-offset
            offset = targetYPos - (containerHeight - view.offsetHeight) / 2
        }
        //}
        //else {
        //when moving upwards, it retrieves previous offset from queue
        // offset = this.offsetQueue.pop() || 0;
        //}

        return Number(offset.toFixed(2));
        //this.refresh();
    }

    requestInternalVerticalScrollPosition(elem): number {
        if (typeof(window) == "undefined") return 0;

        const view = elem.nativeElement,
            rowYPosition = view.offsetTop,
            containerHeight = window.innerHeight;

        //viewport mid point only content below this point will initiate a vertical page scrolling 
        const viewportMidPoint = window.innerHeight / 2;
        var offset = 0.0;
        //if (direction > 0) {
        let targetYPos = rowYPosition;
        //moving downwards, only scroll if next view is hiegher than half the viewport height
        if (targetYPos > viewportMidPoint) {
            //store current y-offset amount in queue
            //this.offsetQueue.push(this.yPosition);
            //when going downwards, it calculates new centering y-offset based on view's top-offset
            offset = targetYPos - (containerHeight - view.offsetHeight) / 2
        }
        //}
        //else {
        //when moving upwards, it retrieves previous offset from queue
        // offset = this.offsetQueue.pop() || 0;
        //}
        return Number(offset.toFixed(2));
        //this.refresh();
    }

    requestHorizontalScrollPosition(elem): number {
        if (typeof(window) == "undefined") return 0;

        const viewInFocus = elem.nativeElement,
            containerWidth = window.innerWidth,
            viewportMidPoint = containerWidth / this.defaultHorizontalPosition;

        let targetXPos = viewInFocus.offsetLeft || viewInFocus.offsetParent && viewInFocus.offsetParent.offsetLeft,
            offsetWidth = viewInFocus.offsetWidth;

        var offset = 0.0;
        if (targetXPos > viewportMidPoint) {
            //only scrolls when item positioned further than mid-point
            offset = targetXPos - (containerWidth - offsetWidth) / this.defaultHorizontalPosition;
        }

        return Number(offset.toFixed(2));
    }

    scrollElementToOffset(req) {
        // this.scrollHelper.scrollToOffset(req.elem, req.x, req.y);
        if (!this.renderer || !req || !req.elem) return;

        let targetElem = req.elem;
        if (req.x !== undefined && req.x > -1) {
            this.renderer.setStyle(targetElem.nativeElement, 'transform', "translateX(-" + req.x + "px)");
        }
        if (req.y !== undefined && req.y > -1) {
            this.renderer.setStyle(targetElem.nativeElement, 'transform', "translateY(-" + req.y + "px)");
        }
        //this.style.transform = "translate3d(0, -" + yPosition + "px, 0)"
        //emits native scrolling Event, used to signal lazy-loaded content (images) to refresh,
        //starts after a 375ms delay, to allow the component's scrolling animations to finalize  
        setTimeout(() => { window.dispatchEvent(new Event("scroll")) }, 300);
    }

    focusPosition( component : any ) : string{
        let position: string;
        if ( component.focusedItemIndex >= component.data.length - 3 && component.data.length >= 3){
          position = "rightside-offset-" + (component.data.length - component.focusedItemIndex).toString();
        }
        else if( component.focusedItemIndex >=2 && component.focusedItemIndex < component.data.length -3 ){
          position =  "offscreen-left";
        }else if( component.focusedItemIndex < 2   ){
          position = component.focusedItemIndex.toString();
        }
    
        return position;
      }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/scrolling/scrolling.helper.service.ts